module.exports = __webpack_public_path__ + "static/media/MedicalMockUp.026ff980.png";